import { useGetBuildQuestQuestions } from ':cloud/queries/BuildQuestQueries/useGetBuildQuestQuestions';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { CompletedTile } from ':cloud/widgets/buildQuest/CompletedTile';
import { LockedTile } from ':cloud/widgets/buildQuest/LockedTile';
import { TileProps } from ':cloud/widgets/buildQuest/types';
import { UnlockedTile } from ':cloud/widgets/buildQuest/UnlockedTile';

type GameTileProps = Pick<TileProps, 'questionId' | 'isUnlocked' | 'variant' | 'onPress'>;

export function GameTile({
  questionId,
  isUnlocked,
  variant,
  onPress,
}: GameTileProps): React.ReactElement {
  const { user } = useGetUser();
  const { items } = useGetBuildQuestQuestions(user.userId);

  const currentItem = items.find((item) => item.questionId === questionId);

  if (!currentItem) {
    return <LockedTile />;
  }

  const { complete, pointValue } = currentItem;

  if (!isUnlocked) {
    return <LockedTile />;
  }
  if (complete) {
    return (
      <CompletedTile
        questionId={questionId}
        pointValue={pointValue}
        variant={variant}
        onPress={onPress}
      />
    );
  }
  return (
    <UnlockedTile
      questionId={questionId}
      pointValue={pointValue}
      variant={variant}
      onPress={onPress}
    />
  );
}
